import React from 'react';
import ViralShareCard from './ViralShareCard';

export default function ViralInviteBanner() {
  return (
    <section className="viral-invite" aria-label="ชวนเพื่อน">
      <ViralShareCard variant="invite" />
    </section>
  );
}
